import actions from 'redux/actions'
import { constants, mixpanel } from 'common/helpers'

import { ShippingType } from 'pages/paymentNew/SubscribePage/util/forms'

import syncUserAndSubscription from './syncUserAndSubscription'


let _applePaySession

type BeginApplePayValues = {
  plan: string
  paymentType: string
  paymentMethod: string
  billing: ShippingType
  shipping: ShippingType
  applePayValidationURL: string
}

type SetupBeginApplePayValues = {
  begin: (any) => any
  sessionName: string
}

const setupBeginApplePay = ({ begin, sessionName }: SetupBeginApplePayValues) => (
  async (values: BeginApplePayValues) => {
    const { paymentType, applePayValidationURL, ...rest } = values

    mixpanel.track(constants.analyticsEvents.tech.beginApplePay)

    const body = {
      paymentType,
      applePayValidationURL,
      ...rest,
    }

    return begin(body)
      .then(
        ({ applePaySession, [sessionName]: session }) => {
          _applePaySession = session
          return applePaySession
        },
        (err) => Promise.reject(err)
      )
  }
)

type CommitApplePayValues = {
  [key: string]: string
}

type SetupCommitApplePayValues = {
  commit: (any) => any
  session: {
    completePayment: (any) => any
  }
  paymentType: string
  sessionName: string
}

const setupCommitApplePay = (values: SetupCommitApplePayValues) => {
  const { commit, session, paymentType, sessionName } = values

  return (values: CommitApplePayValues) => {
    const body = {
      ...values,
      [sessionName]: _applePaySession,
    }

    mixpanel.track(constants.analyticsEvents.tech.commitApplePay)

    return commit(body)
      .then(
        (result) => {
          if (session && session.completePayment) {
            session.completePayment(window.ApplePaySession.STATUS_SUCCESS)
          }

          return syncUserAndSubscription({ paymentType, ...result })
        },
        (err) => {
          if (session && session.completePayment) {
            session.completePayment(window.ApplePaySession.STATUS_FAILURE)
          }

          return Promise.reject(err)
        }
      )
  }
}


export {
  setupBeginApplePay,
  setupCommitApplePay,
}
